// Flags de runtime (localStorage) — ligam/desligam features no cliente SEM deploy.
// bx:mobileV2 é padrão ON; '0' desliga por aparelho (fallback antigo continua no código).
import { useSyncExternalStore } from 'react'

const KEY_MOBILE_V2 = 'bx:mobileV2'
// Anti-ruptura Fase 3: auto-aprovação por exceção. Padrão OFF — só liga quando há
// confiança nos números (decisão "humano no loop"). '1' = ligado por aparelho.
const KEY_AUTO_APPROVAL = 'bx:autoAprovacao'

export function isMobileV2(): boolean {
  if (typeof window === 'undefined') return false
  try {
    // Padrão ON para todos (2026-06-12). '0' = opt-out — o toggle 🧪 no "Mais"
    // vira kill-switch por aparelho (rollback sem deploy).
    return window.localStorage.getItem(KEY_MOBILE_V2) !== '0'
  } catch {
    return true
  }
}

export function setMobileV2(on: boolean): void {
  try {
    window.localStorage.setItem(KEY_MOBILE_V2, on ? '1' : '0')
    window.dispatchEvent(new Event('bx:flags'))
  } catch {
    /* ignore */
  }
}

export function isAutoApproval(): boolean {
  if (typeof window === 'undefined') return false
  try {
    // Padrão OFF: só liga com '1' explícito. O toggle na página do Miguel grava aqui.
    return window.localStorage.getItem(KEY_AUTO_APPROVAL) === '1'
  } catch {
    return false
  }
}

export function setAutoApproval(on: boolean): void {
  try {
    window.localStorage.setItem(KEY_AUTO_APPROVAL, on ? '1' : '0')
    window.dispatchEvent(new Event('bx:flags'))
  } catch {
    /* ignore */
  }
}

function subscribe(cb: () => void): () => void {
  window.addEventListener('bx:flags', cb)
  window.addEventListener('storage', cb)
  return () => {
    window.removeEventListener('bx:flags', cb)
    window.removeEventListener('storage', cb)
  }
}

/** Hook reativo: re-renderiza quando a flag muda (toggle ou outra aba). */
export function useMobileV2(): boolean {
  return useSyncExternalStore(subscribe, isMobileV2, () => false)
}

/** Hook reativo da auto-aprovação por exceção (padrão OFF). */
export function useAutoApproval(): boolean {
  return useSyncExternalStore(subscribe, isAutoApproval, () => false)
}
